import React, {Component} from 'react';
import logo from '../../assets/img/logo-light.svg'

class Logo extends Component {
    render() {
        return (
            <div className="logo-area">
                <a href="/"><img src={logo} alt="Quinns-Logo" /></a>
            </div>
        );
    }
}

export default Logo;